// find the topmost juicer feed if it's in view load the css & js
(() => {
  var feed = $(".socialFeedWidget");
  if(feed.length == 0) 
    return;
  var juicerLoaded = false;
  const desktopHeaderHeight = $("nav").height();
  const BUFFER = 600; //add a buffer for slower network devices so content can start loading quicker
    // for widget containing juicer in view on load
    lazyLoadJuicer();
  function lazyLoadJuicer() {
    var juicerFeedScrollDistance = feed.offset().top;
    var scrollDistance = $(window).scrollTop();
    var windowHeight = $(window).height();

    if (
      scrollDistance >= (juicerFeedScrollDistance - windowHeight - desktopHeaderHeight - BUFFER) &&
      !juicerLoaded
    ) {
      $.getScript("//assets.juicer.io/embed.js");
      $("head").append(
        '<link rel="stylesheet" type="text/css" href="//assets.juicer.io/embed.css">'
      );
      juicerLoaded = true;
      window.removeEventListener("scroll", lazyLoadJuicer);
    }
  }

  window.addEventListener("scroll", lazyLoadJuicer ,{passive: true})

})();
